import { createEntityAdapter } from '@reduxjs/toolkit';
import { FileResponsePrivate } from '@tests/types';

export const backgroundsAdapter = createEntityAdapter<FileResponsePrivate<string>>({
  sortComparer: (a, b) => b.id - a.id,
});
